<!-- DetailsTaxAccordion.vue -->
<script setup lang="ts">
  import { IAccordionProps, ITaxationProps } from '@/types'
  import { Typography } from '@components/index'

  const props = defineProps<IAccordionProps>()
  const emit = defineEmits(['onOpenModal', 'onNextPage'])

  const isOpen = ref(!props.title)
  const haveTaxations = ref(props.taxations)

  const toggleAccordion = () => {
    isOpen.value = !isOpen.value
  }

  const handleSpanClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    const text = target.innerText.trim()
    const dataId = target.getAttribute('data-id')
    if (dataId && text) {
      emit('onOpenModal', {
        id: dataId,
        title: text
      })
    }
  }

  const handleNextClick = (taxations: ITaxationProps[] = [], title: string = '') => {
    emit('onNextPage', taxations, title)
  }
</script>

<template>
  <div class="accordion-wrapper col rounded-3 mb-1">
    <div
      v-if="props.title"
      class="accordion-frame d-flex justify-content-between align-items-center p-4"
      @click="haveTaxations ? handleNextClick(props.taxations, props.title) : toggleAccordion()"
    >
      <Typography :variant="'accordion-title'">{{ props.title }}</Typography>
      <i
        :class="{
          'bi-arrow-right-square': haveTaxations,
          'bi-plus-square-fill': !haveTaxations && !isOpen,
          'bi-dash-square-fill': !haveTaxations && isOpen
        }"
      />
    </div>
    <transition name="accordion">
      <div
        v-if="isOpen && props.description != null"
        class="accordion-content p-4 rounded-bottom-3"
        :class="{ 'rounded-3': !props.title }"
      >
        <Typography :variant="'accordion-description'">
          <div
            @click="handleSpanClick($event)"
            v-html="props.description"
          />
        </Typography>
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
  .accordion-wrapper {
    background-color: #2d3034;
  }

  .accordion-frame {
    cursor: pointer;
    min-height: 60px;
  }

  .accordion-content {
    background-color: #333740;
    overflow: hidden;
  }

  .accordion-rounded-border {
    border-radius: 9px;
  }

  @keyframes accordion {
    0% {
      max-height: 0;
      opacity: 0;
    }

    100% {
      max-height: 1000px;
      opacity: 1;
    }
  }

  .accordion-enter-active {
    animation: accordion 0.5s ease-in-out;
  }

  .accordion-leave-active {
    animation: accordion 0.3s ease-in-out reverse;
  }
</style>
